function parseFileListToTree(files) {
  const tree = [];
  const fileMap = {}; // Map for tracking nodes by their ID

  let idCounter = 1; // To assign unique IDs to each node

  files.forEach((filePath) => {
    const pathParts = filePath.split("/"); // Split the file path by "/"
    let parentId = 0; // Root parent is 0

    pathParts.forEach((part, index) => {
      // Construct the full path for each part
      const fullPath = pathParts.slice(0, index + 1).join("/");

      // Check if the node already exists in the map
      const existingNode = tree.find(
        (node) => node.text === part && node.parent === parentId
      );

      if (existingNode) {
        // If it exists, use its ID as the next parentId
        parentId = existingNode.id;
      } else {
        // If it doesn't exist, create a new node
        const newNode = {
          id: idCounter++,
          parent: parentId,
          text: part,
          fullPath: fullPath, // Store the full path of the file or folder
          droppable: index < pathParts.length - 1, // If not the last part, it's a folder
        };

        tree.push(newNode);
        fileMap[part] = newNode;
        // Update the parentId for the next iteration
        parentId = newNode.id;
      }
    });
  });

  return tree;
}

function nestTreeData(flatData) {
  const idMap = {};
  const nestedData = [];

  // Create a map of each node by its ID and add empty `children` arrays
  flatData.forEach((node) => {
    idMap[node.id] = { ...node, children: [] };
  });

  // Build the nested structure
  flatData.forEach((node) => {
    if (node.parent === 0) {
      // Root node
      nestedData.push(idMap[node.id]);
    } else {
      // Child node
      const parent = idMap[node.parent];
      if (parent) {
        parent.children.push(idMap[node.id]);
      }
    }
  });

  // Sort folders before files at each level
  function sortTree(tree) {
    tree.forEach((node) => {
      if (node.children && node.children.length > 0) {
        // Sort children with folders (droppable: true) before files
        node.children.sort((a, b) => {
          if (a.droppable === b.droppable) {
            return a.text.localeCompare(b.text); // Sort alphabetically if both are folders or both are files
          }
          return a.droppable ? -1 : 1; // Place folders (droppable: true) before files
        });

        // Recursively sort each level
        sortTree(node.children);
      }
    });
  }

  // Sort the top-level items in `nestedData`
  sortTree(nestedData);

  return nestedData;
}

export { parseFileListToTree, nestTreeData };
